import { useEffect, useState } from 'react';
import { Button, testIdProp } from '@givmo/design-system';

export const EXTERNAL_STATUS_REFETCH_MS = 30_000;

export function formatLastChecked(lastCheckedAt: number, now = Date.now()): string {
  if (lastCheckedAt <= 0) return 'not yet';
  const seconds = Math.max(0, Math.floor((now - lastCheckedAt) / 1000));
  if (seconds < 10) return 'just now';
  if (seconds < 60) return `${seconds} seconds ago`;
  const minutes = Math.floor(seconds / 60);
  return `${minutes} ${minutes === 1 ? 'minute' : 'minutes'} ago`;
}

export function ExternalStatusRefresh({
  lastCheckedAt,
  refreshing,
  onRefresh,
  testId,
}: {
  lastCheckedAt: number;
  refreshing: boolean;
  onRefresh: () => void;
  testId: string;
}) {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const timer = window.setInterval(() => setNow(Date.now()), EXTERNAL_STATUS_REFETCH_MS);
    return () => window.clearInterval(timer);
  }, []);

  return (
    <div
      className="flex flex-wrap items-center justify-between gap-8 text-s12 text-text-tertiary"
      {...testIdProp(testId)}
    >
      <span>Last checked {formatLastChecked(lastCheckedAt, now)}</span>
      <Button
        appearance="saas"
        tone="secondary"
        size="sm"
        loading={refreshing}
        onClick={onRefresh}
        testId={`${testId}-button`}
      >
        Refresh
      </Button>
    </div>
  );
}
